import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from '../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';

const defaultSorted = [{ dataField: 'code', order: 'desc' }];
const List = (props) => {
  const { entities, totalCount, intl, setQueryParams, listLoading } = props;
  const finDateLabel = intl.formatMessage({ id: 'FINANCE.LABEL.FINDATE' });
  const productCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PRODUCTCOUNT',
  });
  const productAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PRODUCTAMOUNT',
  });
  const bundleCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.BUNDLECOUNT',
  });
  const reserveCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.RESERVECOUNT',
  });
  const saleOrderedCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.SALEORDEREDCOUNT',
  });
  const orderedCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.ORDEREDCOUNT',
  });
  const purchaseItemCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PURCHASEITEMCOUNT',
  });
  const purchaseItemAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.PURCHASEITEMAMOUNT',
  });
  const stockCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.STOCKCOUNT',
  });
  const stockAmountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.STOCKAMOUNT',
  });
  const salesOrderCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.SALESORDERCOUNT',
  });
  const salesHoldCountLabel = intl.formatMessage({
    id: 'FINANCE.STOCK.LABEL.SALESHOLDCOUNT',
  });

  // Table columns
  const columns = [
    {
      dataField: 'finDate',
      text: finDateLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
      style: {
        minWidth: '110px',
        width: '110px',
      },
    },
    {
      dataField: 'productCount',
      text: productCountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'bundleCount',
      text: bundleCountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'reserveCount',
      text: reserveCountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      classes: 'text-right bg-light-primary',
    },

    {
      dataField: 'saleOrderedCount',
      text: saleOrderedCountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'orderedCount',
      text: orderedCountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'productAmount',
      text: productAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-primary',
    },
    {
      dataField: 'stockCount',
      text: stockCountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'stockAmount',
      text: stockAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-success',
    },
    {
      dataField: 'purchaseItemCount',
      text: purchaseItemCountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-info',
    },
    {
      dataField: 'purchaseItemAmount',
      text: purchaseItemAmountLabel,
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PriceColumnFormatter,
      classes: 'text-right bg-light-info',
    },
    {
      dataField: 'salesOrderCount',
      text: salesOrderCountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-right bg-light-warning',
    },
    {
      dataField: 'salesHoldCount',
      text: salesHoldCountLabel,
      sort: true,
      sortCaret: sortCaret,
      classes: 'text-right bg-light-warning',
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPage: 400,
    page: 1,
  };
  return (
    <BootstrapTable
      key='financeStockList'
      wrapperClasses='table-responsive'
      bordered={true}
      classes='table table-head-custom table-vertical-center overflow-hidden'
      bootstrap4
      remote
      keyField='finDate'
      data={entities === null ? [] : entities}
      columns={columns}
      defaultSorted={defaultSorted}
    >
      <PleaseWaitMessage entities={entities} />
      <NoRecordsFoundMessage entities={entities} />
    </BootstrapTable>
  );
};

export default injectIntl(List);
